import { render, staticRenderFns } from "./Name.vue?vue&type=template&id=19f93f69&scoped=true"
import script from "./Name.vue?vue&type=script&lang=js"
export * from "./Name.vue?vue&type=script&lang=js"
import style0 from "./Name.vue?vue&type=style&index=0&id=19f93f69&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f93f69",
  null
  
)

export default component.exports